<template>

<svg
    class="strutLayers wrapperSvgNeg30 marginstrutMax2000" xmlns="http://www.w3.org/2000/svg"
    width="3174.1" height="4940.94" viewBox="-900 -400 14900 11000">

  <g
      v-for="postInfo in branchStandPosInfo"
      :key="postInfo.index"
      class="rightGroup postStandSector"
      v-bind:style="postInfo.style"
    >
    <!-- Manages stag/strut-->
    <template v-if="postInfo.index > 0">
      <Strut1000 v-if="selectedStagSection.width == 1000" />
      <Strut1500 v-if="selectedStagSection.width == 1500" />
    </template>

    <!-- The far arms of a double sided stand go behind the post -->
    <template v-if="doubleBranch && selectedArm.length == 600">
      <Arm600
          v-for="armPos in armPosInfo"
          :key="'far-' + armPos.index"
          :doubleBranch="doubleBranch"
          side="far"
          v-bind:style="armPos.stylePos"
      />
    </template>

    <template v-if="doubleBranch && selectedArm.length == 1000">
      <Arm1000
          v-for="armPos in armPosInfo"
          :key="'far-' + armPos.index"
          :doubleBranch="doubleBranch"
          side="far"
          v-bind:style="armPos.stylePos"
      />
    </template>

    <!-- Manages the post, which carries its own foot for this series -->
    <template v-if="doubleBranch">
      <PostDouble600Arm1976 v-if="footLength == 1380 && postOpt == 1976" />
      <PostDouble1000Arm1976 v-if="footLength == 2180 && postOpt == 1976" />
      <PostDouble600Arm2432 v-if="footLength == 1380 && postOpt == 2432" />
      <PostDouble1000Arm2432 v-if="footLength == 2180 && postOpt == 2432" />
    </template>
    <template v-else>
      <PostSingle600Arm1976 v-if="footLength == 780 && postOpt == 1976" />
      <PostSingle1000Arm1976 v-if="footLength == 1180 && postOpt == 1976" />
      <PostSingle600Arm2432 v-if="footLength == 780 && postOpt == 2432" />
      <PostSingle1000Arm2432 v-if="footLength == 1180 && postOpt == 2432" />
    </template>

    <!-- The near arms go in front of it -->
    <template v-if="selectedArm.length == 600">
      <Arm600
          v-for="armPos in armPosInfo"
          :key="'near-' + armPos.index"
          :doubleBranch="doubleBranch"
          side="near"
          v-bind:style="armPos.stylePos"
      />
    </template>

    <template v-if="selectedArm.length == 1000">
      <Arm1000
          v-for="armPos in armPosInfo"
          :key="'near-' + armPos.index"
          :doubleBranch="doubleBranch"
          side="near"
          v-bind:style="armPos.stylePos"
      />
    </template>
  </g>

  <ArrowLength
      :startX="arrowLengthPosBaseCoords.x"
      :startY="arrowLengthPosBaseCoords.y"
      :totalLength="totalLength"
  />

  <ArrowDepth
      :startX="arrowDepthPosBaseCoords.x"
      :startY="arrowDepthPosBaseCoords.y"
      :totalDepth="totalDepth"
  />

  <ArrowHeight
      :startX="arrowHeightPosBaseCoords.x"
      :startY="arrowHeightPosBaseCoords.y"
      :totalHeight="totalHeight"
  />
</svg>

</template>
<script>
import Arm600 from "@/components/svg-parts/falla/arms/Arm600-F.vue";
import Arm1000 from "@/components/svg-parts/falla/arms/Arm1000-F.vue";

import PostSingle600Arm1976 from "@/components/svg-parts/falla/posts/PostSingle600Arm1976-F.vue";
import PostSingle1000Arm1976 from "@/components/svg-parts/falla/posts/PostSingle1000Arm1976-F.vue";
import PostSingle600Arm2432 from "@/components/svg-parts/falla/posts/PostSingle600Arm2432-F.vue";
import PostSingle1000Arm2432 from "@/components/svg-parts/falla/posts/PostSingle1000Arm2432-F.vue";

import PostDouble600Arm1976 from "@/components/svg-parts/falla/posts/PostDouble600Arm1976-F.vue";
import PostDouble1000Arm1976 from "@/components/svg-parts/falla/posts/PostDouble1000Arm1976-F.vue";
import PostDouble600Arm2432 from "@/components/svg-parts/falla/posts/PostDouble600Arm2432-F.vue";
import PostDouble1000Arm2432 from "@/components/svg-parts/falla/posts/PostDouble1000Arm2432-F.vue";

// Struts
import Strut1000 from "@/components/svg-parts/falla/struts/Strut1000-F.vue";
import Strut1500 from "@/components/svg-parts/falla/struts/Strut1500-F.vue";

// Arrows
import ArrowHeight from "@/components/svg-parts/misc/ArrowHeight.vue";
import ArrowLength from "@/components/svg-parts/misc/ArrowLength.vue";
import ArrowDepth from "@/components/svg-parts/misc/ArrowDepth.vue";

import {mapGetters} from "vuex";

export default {
  name: "FallaCombinedParts.vue",
  components: {
    Arm600,
    Arm1000,

    PostSingle600Arm1976,
    PostSingle1000Arm1976,
    PostSingle600Arm2432,
    PostSingle1000Arm2432,

    PostDouble600Arm1976,
    PostDouble1000Arm1976,
    PostDouble600Arm2432,
    PostDouble1000Arm2432,

    Strut1000,
    Strut1500,

    ArrowHeight,
    ArrowLength,
    ArrowDepth
  },

  computed: {
    selectedStagSection: {
      get() {
        return this.$store.state.selectedStagSection;
      },
    },
    selectedArm: {
      get() {
        return this.$store.state.selectedCarryingArm;
      }
    },
    doubleBranch: {
      get() {
        return this.$store.state.doubleBranch;
      }
    },
    postOpt: {
      get() {
        return this.$store.state.selectedPostOpt;
      }
    },
    footLength: {
      get() {
        return this.$store.state.postFootLength;
      }
    },
    totalHeight: {
      get() {
        return this.$store.state.totalHeight;
      }
    },
    totalLength: {
      get() {
        return this.$store.state.totalLength;
      }
    },
    totalDepth: {
      get() {
        return this.$store.state.totalDepth;
      }
    },
    ...mapGetters([
      "armPosInfo",
      "branchStandPosInfo",
      "arrowHeightPosBaseCoords",
      "arrowLengthPosBaseCoords",
      "arrowDepthPosBaseCoords"
    ]),
  }
};
</script>

<style scoped>
</style>
